import { Button, Typography } from '@/ui-kit';
import styles from './half-done.module.scss';
import { routesApp } from '@/constans/routes';
import { RemoderationIcon } from '@/assets/icons';
import clsx from 'clsx';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
    variant?: 'primary' | 'secondary' |'tertiary'
    onInit?: () => void
}

export const HalfDone: React.FC<Props> = ({ variant = 'primary', onInit }) => {
    useEffect(() => {
        onInit?.()
    }, [])

    const { t } = useTranslation();

    return (
        <div className={
            clsx(
                styles.finishFillYourselfDataCard,
                variant === 'secondary' &&
                styles.secondaryWrapper,
                variant === 'tertiary' &&
                styles.tertiaryWrapper,
            )
        }>
            <div className={styles.finishFillYourselfDataCardContent}>
                <RemoderationIcon
                    className={
                        clsx(
                            styles.finishFillYourselfDataCardContentIcon,
                            variant === 'secondary' && styles.finishFillYourselfDataCardContentIconSecondary
                        )
                    } />
                <Typography
                    fontWeight="semibold"
                    className={styles.finishFillYourselfDataCardContentTitle}
                    center
                    typeColor={variant === 'tertiary' ? 'white' : undefined}>
                    {t('profile.finish_fill_yourself_data_title')}
                </Typography>
                <Typography
                    center
                    typeColor={variant === 'tertiary' ? 'white' : undefined}>
                    <Trans i18nKey="finish_fill_yourself_data_subtitle_secondary" />
                </Typography>
            </div>
            <Button
                typeColor={variant === 'tertiary' ? 'white' : 'orange'}
                textColor={variant === 'tertiary' ? 'black' : undefined}
                to={routesApp.profileEdit}
                isLink
                className={styles.finishFillYourselfDataCardBtn}>
                {t('to_fill')}
            </Button>
        </div>
    );
};
